import React from 'react'
import { Switch, Text, TouchableOpacity, View } from 'react-native'
import { useTheme } from '../../hooks/useTheme'

/** No separate background; disabled text remains readable on the combat card. */
export function ContinuousAttackControl({ value, available, onChange, children }: {
  value: boolean
  available: boolean
  onChange: (value: boolean) => void
  children?: React.ReactNode
}) {
  const { theme } = useTheme()
  return <View testID="continuous-attack-control" className="flex-row items-center gap-1.5 px-1.5 py-1">
    <Switch value={value} onValueChange={next => { if (available) onChange(next) }} disabled={!available}
      accessibilityLabel="Toggle continuous attack" trackColor={{ false: '#4a5a2a', true: '#a01818' }} thumbColor="#fff"
      style={{ transform: [{ scale: 0.75 }], opacity: available ? 1 : 0.7 }} />
    <TouchableOpacity onPress={() => { if (available) onChange(!value) }} disabled={!available}
      accessibilityLabel="Toggle continuous attack" accessibilityRole="button" testID="continuous-attack-toggle">
      <Text className="text-ink text-[10px] font-typed" style={!available ? { color: theme === 'dark' ? '#b4b79e' : '#66694f' } : undefined}>Continuous Attack</Text>
    </TouchableOpacity>
    <View className="flex-1" />
    {children}
  </View>
}
